// @flow

import React from 'react';
import { localizeEnum } from 'shared/utils';
import Pill from '.';

type Props = {
  width?: string | number,
  status:
    | 'WAITING_FOR_CONFIRMATION'
    | 'CONFIRMED'
    | 'WAITING_FOR_PRODUCTION'
    | 'IN_PRODUCTION'
    | 'READY_FOR_SHIPMENT'
    | 'SHIPPED'
    | 'DELIVERED',
};

const ThemeStatusMap = {
  WAITING_FOR_CONFIRMATION: 'grey',
  CONFIRMED: 'blue',
  WAITING_FOR_PRODUCTION: 'purple',
  IN_PRODUCTION: 'orange',
  READY_FOR_SHIPMENT: 'teal',
  SHIPPED: 'indigo',
  DELIVERED: 'green',
};

const LabelMap = {
  WAITING_FOR_CONFIRMATION: 'Waiting for Confirmation',
  CONFIRMED: 'Confirmed',
  WAITING_FOR_PRODUCTION: 'Waiting for Production',
  IN_PRODUCTION: 'In Production',
  READY_FOR_SHIPMENT: 'Ready for Shipment',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
};

const OrderStatusPill = ({ status, width }: Props) => (
  <Pill theme={ThemeStatusMap[status] || 'grey'} width={width}>
    {LabelMap[status] || localizeEnum(status)}
  </Pill>
);

OrderStatusPill.defaultProps = {
  width: undefined,
};

export default OrderStatusPill;
